import { createRouteRef, PageBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/catalog',
        noHeader: true,
        routeRef: createRouteRef({ aliasFor: 'catalog.catalogIndex' }),
        loader: () => import('./CustomCatalogPage').then(m => <m.CustomCatalogPage />),
      },
    }),
  ],
});
